export default {
  'menu.welcome': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登錄',
  'menu.register': '註冊',
  'menu.register-result': '註冊結果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.settings': '個人設置',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
  'menu.充值': '充值',
  'menu.充值.充值': '充值',
  'menu.充值.查看': '查看',
  'menu.卡余额提醒': '卡餘額提醒',
  'menu.消纳': '消納',
  'menu.消纳.消纳': '消納',
  'menu.消纳.新建消纳': '新建消納',
  'menu.消纳.编辑': '編輯',
  'menu.消纳.查看': '查看',
  'menu.统计分析': '統計分析',
  'menu.规则设置': '規則設置',
  'menu.系统设置': '系統設置',
  'menu.系统设置.成员管理': '成員管理',
  'menu.系统设置.成员列表': '成員列表',
  'menu.系统设置.添加成员': '添加成員',
  'menu.系统设置.编辑成员': '編輯成員',
  'menu.系统设置.查看成员': '查看成員',
  'menu.系统设置.角色与权限': '角色與權限',
  'menu.系统设置.角色列表': '角色列表',
  'menu.系统设置.添加角色': '添加角色',
  'menu.系统设置.编辑角色': '編輯角色',
  'menu.系统设置.查看角色': '查看角色',
  'menu.成员管理': '成員管理',
  'menu.成员列表': '成員列表',
  'menu.添加成员': '添加成員',
  'menu.编辑成员': '編輯成員',
  'menu.查看成员': '查看成員',
  'menu.角色与权限': '角色與權限',
  'menu.角色列表': '角色列表',
  'menu.添加角色': '添加角色',
  'menu.编辑角色': '編輯角色',
  'menu.查看角色': '查看角色',
  'menu.基本信息': '基本資訊',
  'menu.基本信息.服务片区': '服務片區',
  'menu.基本信息.新建片区': '新建片區',
  'menu.基本信息.编辑片区': '編輯片區',
  'menu.基本信息.商户信息': '商戶資訊',
  'menu.基本信息.新建商户': '新建商戶',
  'menu.基本信息.编辑商户': '編輯商戶',
  'menu.基本信息.查看商户': '查看商戶',
  'menu.基本信息.新增签订合同': '新增簽訂合同',
  'menu.基本信息.编辑合同': '編輯合同',
  'menu.基本信息.查看合同': '查看合同',
  'menu.基本信息.新建人员': '新建人員',
  'menu.基本信息.编辑人员': '編輯人員',
  'menu.基本信息.运营信息': '運營資訊',
  'menu.基本信息.主体信息': '主體資訊',
  'menu.基本信息.新建主体': '新建主體',
  'menu.基本信息.编辑主体': '編輯主體',
  'menu.基本信息.桶标RFID信息': '桶標RFID資訊',
  'menu.基本信息.新建桶标RFID信息': '新建桶標RFID資訊',
  'menu.基本信息.编辑桶标RFID信息': '編輯桶標RFID資訊',
  'menu.服务片区': '服務片區',
  'menu.新建片区': '新建片區',
  'menu.商户信息': '商戶資訊',
  'menu.新建商户': '新建商戶',
  'menu.编辑商户': '編輯商戶',
  'menu.查看商户': '查看商戶',
  'menu.新增签订合同': '新增簽訂合同',
  'menu.编辑合同': '編輯合同',
  'menu.查看合同': '查看合同',
  'menu.新建人员': '新建人員',
  'menu.编辑人员': '編輯人員',
  'menu.运营信息': '運營資訊',
  'menu.新建清运记录': '新建清運記錄',
  'menu.编辑清运记录': '編輯清運記錄',
  'menu.清运记录': '清運記錄',
  'menu.到期提醒': '到期提醒',
  'menu.对账': '對賬',
  'menu.对账.对账列表': '對賬列表',
  'menu.对账.手动对账': '手動對賬',
  'menu.对账.查看': '查看',
  'menu.对账.新建手动对账': '新建手動對賬',
  'menu.对账.去对账': '去對賬',
  'menu.对账列表': '對賬列表',
  'menu.手动对账': '手動對賬',
  'menu.开票': '開票',
  'menu.开票.开票列表': '開票列表',
  'menu.开票.手动开票': '手動開票',
  'menu.开票.申请开票': '申請開票',
  'menu.开票.查看开票': '查看開票',
  'menu.开票.发起手动开票': '發起手動開票',
  'menu.开票列表': '開票列表',
  'menu.手动开票': '手動開票',
  'menu.回款': '回款',
  'menu.回款.回款列表': '回款列表',
  'menu.回款.手动回款': '手動回款',
  'menu.回款.完成回款': '完成回款',
  'menu.回款.查看': '查看',
  'menu.回款.新建手动回款记录': '新建手動回款記錄',
  'menu.回款列表': '回款列表',
  'menu.手动回款': '手動回款',
  'menu.现结回款': '現結回款',
  'menu.消纳.消纳': '消納',
  'menu.消纳.新建消纳': '新建消納',
  'menu.消纳.编辑': '編輯',
  'menu.消纳.查看': '查看',
  'menu.统计分析': '統計分析',
  'menu.规则设置': '規則設置',
  'menu.系统设置': '系統設置',
  'menu.系统设置.成员管理': '成員管理',
  'menu.系统设置.成员列表': '成員列表',
  'menu.系统设置.添加成员': '添加成員',
  'menu.系统设置.编辑成员': '編輯成員',
  'menu.系统设置.查看成员': '查看成員',
  'menu.系统设置.角色与权限': '角色與權限',
  'menu.系统设置.角色列表': '角色列表',
  'menu.系统设置.添加角色': '添加角色',
  'menu.系统设置.编辑角色': '編輯角色',
  'menu.系统设置.查看角色': '查看角色',
  'menu.成员管理': '成員管理',
  'menu.成员列表': '成員列表',
  'menu.添加成员': '添加成員',
  'menu.编辑成员': '編輯成員',
  'menu.查看成员': '查看成員',
  'menu.角色与权限': '角色與權限',
  'menu.角色列表': '角色列表',
  'menu.添加角色': '添加角色',
  'menu.编辑角色': '編輯角色',
  'menu.查看角色': '查看角色',
  'menu.基本信息': '基本資訊',
  'menu.基本信息.服务片区': '服務片區',
  'menu.基本信息.新建片区': '新建片區',
  'menu.基本信息.编辑片区': '編輯片區',
  'menu.基本信息.商户信息': '商戶資訊',
  'menu.基本信息.新建商户': '新建商戶',
  'menu.基本信息.运营信息': '運營資訊',
  'menu.服务片区': '服務片區',
  'menu.新建片区': '新建片區',
  'menu.商户信息': '商戶資訊',
  'menu.新建商户': '新建商戶',
  'menu.运营信息': '運營資訊',
  'menu.车辆管理': '車輛管理',
  'menu.车辆管理.一车一档': '一車一檔',
  'menu.车辆管理.新建车辆': '新建車輛',
  'menu.车辆管理.编辑车辆': '編輯車輛',
  'menu.车辆管理.查看车辆详情': '查看車輛詳情',
  'menu.车辆管理.运营记录': '運營記錄',
  'menu.车辆管理.车辆过户': '車輛過戶',
  'menu.数据上报': '數據上報',
  'menu.数据上报.待上报数据': '待上報數據',
  'menu.数据上报.一键补录': '一鍵補錄',
  'menu.数据上报.编辑上报数据': '編輯上報數據',
  'menu.数据上报.上报配置': '上報配置',
  'menu.数据上报.历史记录': '歷史記錄',
  'menu.数据上报.数据明细': '數據明細',
  'menu.数据获取': '數據獲取',
  'menu.数据获取.上报主体获取': '上報主體獲取',
  'menu.数据获取.上报车辆获取': '上報車輛獲取',
  'menu.数据获取.上报垃圾类型获取': '上報垃圾類型獲取',
  'menu.运营单位管理': '運營單位管理',
  'menu.新建运营单位管理': '新建運營單位管理',
  'menu.编辑运营单位管理': '編輯運營單位管理',
};
